// @flow
import {
  DELETE_EXTERNAL_REPORT_LOADING,
  DELETE_EXTERNAL_REPORT_SUCCESS,
  DELETE_EXTERNAL_REPORT_ERROR,
  ADD_EXTERNAL_REPORT_LOADING,
  ADD_EXTERNAL_REPORT_SUCCESS,
  ADD_EXTERNAL_REPORT_ERROR,
  UPDATE_EXTERNAL_REPORT_LOADING,
  UPDATE_EXTERNAL_REPORT_SUCCESS,
  UPDATE_EXTERNAL_REPORT_ERROR,
} from '../actions/externalReportsActions';

export default (state: Object = {}, action: Object) => {
  switch (action.type) {
    case DELETE_EXTERNAL_REPORT_LOADING:
    case ADD_EXTERNAL_REPORT_LOADING:
    case UPDATE_EXTERNAL_REPORT_LOADING:
      return {
        ...state,
        status: 'LOADING',
      };
    case DELETE_EXTERNAL_REPORT_SUCCESS:
    case ADD_EXTERNAL_REPORT_SUCCESS:
    case UPDATE_EXTERNAL_REPORT_SUCCESS:
      return {
        ...state,
        status: 'SUCCESS',
        data: action.data,
      };
    case DELETE_EXTERNAL_REPORT_ERROR:
    case ADD_EXTERNAL_REPORT_ERROR:
    case UPDATE_EXTERNAL_REPORT_ERROR:
      return {
        ...state,
        status: 'ERROR',
        error: action.error,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./client/src/reducers/externalReportsReducer.js